import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import React, { useMemo } from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { useFindCandidateRolesQuery } from 'service/candidateQuery/candidateQuery';

function CandidateRoleForm() {
  const { data } = useFindCandidateRolesQuery('');

  const rolesOptions = useMemo(() => {
    return Array.isArray(data) ? [{ label: 'Select', value: '' }, ...data] : [];
  }, [data]);

  return (
    <Row className="g-5">
      <Col xs={12} xl={8}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="role">Preferred role</FormLabel>
          <Select name="role" id="role" options={rolesOptions} />
        </FormGroup>
      </Col>
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="currentAnnualEarning">
            Current annual earnings (In Indian Rupees)
          </FormLabel>
          <Input name="currentAnnualEarning" id="currentAnnualEarning" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="expectedAnnualEarning">
            Expected annual earnings (In Indian Rupees)
          </FormLabel>
          <Input name="expectedAnnualEarning" id="expectedAnnualEarning" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CandidateRoleForm;
